import { ImportWorkOrdersWorkspace } from "@/components/import-work-orders/ImportWorkOrdersWorkspace";
import { DraftBanner } from "@/components/shared/draft-banner";
import { PageHeader } from "@/components/shared/page-header";

export function ImportWorkOrdersPage() {
  return (
    <div className="space-y-6">
      <DraftBanner
        epic="EPIC-008"
        run="HR-001"
        subtitle="Import Work Orders — CSV parsing and validation happen in your browser; nothing is sent to NetSuite."
      />
      <PageHeader
        title="Import Work Orders"
        description="Upload a CSV of new work orders, fix anything that doesn't match a real item or location, then create them all at once."
      />
      <ImportWorkOrdersWorkspace />
    </div>
  );
}
